import React from "react";


const BackgroundVideo = () => {
  return (
    <div className="video-container">
      <iframe
        src="https://www.youtube.com/embed/drlXQiMqLmE?autoplay=1&mute=1&controls=0&rel=0&modestbranding=1&loop=1&playlist=drlXQiMqLmE&disablekb=1"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        title="Background Video"
       style={{width:'100%'}}></iframe>

    </div>
  );
};

export default BackgroundVideo;

